import { ParsedQuery } from 'query-string';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormOptions } from 'types/forms';
import { FilterDataDto } from 'types/utils';
import { useDecodeFilters } from 'utils/filters/encodeDecodeFilters';

const useActiveFilters = ({
  filterData,
  filtersValues,
}: {
  filterData?: FilterDataDto;
  filtersValues?: ParsedQuery;
}) => {
  const decodedFilters = useDecodeFilters();
  const currFilters = filtersValues || decodedFilters;
  const { t } = useTranslation();

  const filtersOptions = useMemo(() => {
    if (!currFilters || !filterData) {
      return {};
    }

    return Object.keys(currFilters).reduce((acc, key) => {
      const filterValue = currFilters[key];
      if (Array.isArray(filterValue)) {
        return {
          ...acc,
          [key]: {
            label: `${t(key)}: `.concat(
              filterValue
                .map((id) => {
                  if (!id) {
                    return '';
                  }
                  if (!filterData[key] || !filterData[key][id] || !filterData[key][id].label) {
                    return t(id);
                  }

                  return filterData[key][id]?.label;
                })
                .join(', '),
            ),
          },
        };
      }
      if (
        filterValue &&
        filterData &&
        filterData[key] &&
        filterData[key][filterValue] &&
        filterData[key][filterValue].label
      ) {
        return {
          ...acc,
          [key]: { label: `${t(key)}: ${filterData[key][filterValue].label}` },
        };
      }

      return {
        ...acc,
        [key]: { label: `${t(key)}: ${!!filterValue && t(filterValue)}` },
      };
    }, {} as FormOptions);
  }, [filterData, currFilters]);

  return { filtersOptions };
};

export default useActiveFilters;
